import { AbstractApiModel } from './abstract-api-model';

export class MicroInstallStatus extends AbstractApiModel<MicroInstallStatus> {
  microJson: Record<string, any[]> = {};
  allMicros: any[] = [];
  mismatchedMicros: string[] = [];

  deserialize(json: any): this {
    this.microJson = json;

    this.allMicros = ([] as any[]).concat(
      ...Object.values(json).map(arr => Array.isArray(arr) ? arr : [])
    );
    this.mismatchedMicros = this.allMicros
      .filter(m => m.current_version !== m.desired_version)
      .map(m => m.micro);

    return super.deserialize(json);
  }
}
